import ReactDOM from "react-dom/client";
import ReactDOMServer from "react-dom/server";
import { hydrateRoot } from "react-dom/client";

import reportWebVitals from "./reportWebVitals";
import React, { lazy, Suspense } from "react";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import store from "./store";

import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);

// ReactDOM.hydrate(
//   <BrowserRouter>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );

// const root = ReactDOMServer.renderToString(
//   <BrowserRouter>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </BrowserRouter>
// );

// const domNode = document.getElementById("root");
// domNode.innerHTML = `${root}`;

// reportWebVitals();
